module.exports = __webpack_public_path__ + "static/media/backgroud-transaction.9a4af2f2.svg";